import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

interface StickySaveBarProps {
  isDirty: boolean;
  isSaving: boolean;
  onSave: () => void;
  onDiscard: () => void;
}

export function StickySaveBar({ isDirty, isSaving, onSave, onDiscard }: StickySaveBarProps) {
  const { t } = useTranslation('pricingV2');
  if (!isDirty) return null;
  return (
    <div className="sticky bottom-0 inset-x-0 z-10 flex items-center justify-between border-t border-border bg-surface px-6 py-3 shadow-md">
      <span className="text-sm text-muted">{t('saveBar.unsavedChanges')}</span>
      <div className="flex gap-2">
        <Button variant="ghost" onClick={onDiscard} disabled={isSaving}>{t('saveBar.discard')}</Button>
        <Button onClick={onSave} loading={isSaving}>{t('saveBar.saveChanges')}</Button>
      </div>
    </div>
  );
}
